<template>
  <div class="modal-container" @click.stop.prevent="onClose">
    <div class="modal-content">
      <div class="modal-close">
        <i class="fa fa-times"></i>
      </div>
      <div>
        <form class="wpcf7-form" novalidate="novalidate" @sumbit.prevent>
          <div style="max-width: 300px">
            <span style="display: inline-block;text-align: center">
              {{ $t('fillFormContact') }}
            </span>
            <br />
            <span class="wpcf7-form-control-wrap text-544">
              <input
                type="text"
                name="name"
                size="40"
                class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required"
                :placeholder="$t('yourName')"
                v-model="name"
                @blur="$v.name.$touch()"
              />
              <div class="error" v-if="$v.name.$dirty && !$v.name.required">
                {{ $t('appealForm.emptyName') }}
              </div>
            </span>
            <br />
            <span class="wpcf7-form-control-wrap tel-958">
              <input
                type="tel"
                name="phone"
                size="40"
                class="wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel"
                :placeholder="$t('yourPhone')"
                maxlength="19"
                @input="phoneMask()"
                v-model="phone"
                @blur="$v.phone.$touch()"
              />
              <div class="error" v-if="$v.phone.$dirty && !$v.phone.required">
                {{ $t('appealForm.emptyPhone') }}
              </div>
              <div class="error" v-if="$v.phone.$dirty && !$v.phone.alpha">
                {{ $t('appealForm.invalidPhone') }}
              </div>
            </span>
            <span class="wpcf7-form-control-wrap dynamichidden-463"> </span>
            <span class="product-oneclick">
              <b>{{ $t('product') }}:</b> {{ productName }}
            </span>
            <p></p>
            <p v-if="!sent">
              <input
                type="button"
                :value="$t('send')"
                class="wpcf7-form-control wpcf7-submit btn-send"
                @click.stop.prevent="onSubmit"
              />
              <span class="ajax-loader"></span>
            </p>
            <div class="success-msg" v-else>
              <p>{{ $t('appealForm.formSent') }}</p>
            </div>
          </div>
          <div class="wpcf7-response-output wpcf7-display-none"></div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'
export default {
  name: 'PreOrderModal',
  data() {
    return {
      name: '',
      phone: '',
      sent: false,
    }
  },
  computed: {
    productName() {
      const product = this.$store.state.productModal
      return product[`name_${this.$i18n.locale}`]
        ? product[`name_${this.$i18n.locale}`]
        : product.name
        ? product.name
        : ''
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      } else {
        this.$store
          .dispatch('submitPreOrder', {
            name: this.name,
            phone: this.phone,
            product: this.$store.state.product._id,
          })
          .then(() => {
            this.$v.$reset()
            this.sent = true
            this.name = ''
            this.phone = ''
            console.log('*OK')
            // this.setQuickOrderModal()
          })
          .catch(() => {
            console.log('*NOT SUBMITTED')
          })
      }
    },
    onClose(e) {
      if (
        e.target.className === 'modal-container' ||
        e.target.className === 'fa fa-times'
      ) {
        this.$store.commit('setPreOrderModal', null)
      }
    },
    phoneMask() {
      const x = this.phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/)

      this.phone = !x[2]
        ? x[1]
        : '(' +
          x[1] +
          ') ' +
          x[2] +
          (x[3] ? '-' + x[3] : '') +
          (x[4] ? '-' + x[4] : '')
      this.$v.phone.$touch()
    },
  },
  mixins: [validationMixin],
  validations: {
    name: {
      required,
    },
    phone: {
      required,
      alpha: helpers.regex(
        'alpha',
        /\((0)(\d)(\d)\)\s(\d)(\d)(\d)(-)(\d)(\d)(-)(\d)(\d)/i
      ),
    },
  },
}
</script>

<style>
.modal-container {
  position: fixed;
  display: flex;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999999;
}
.modal-content {
  border-radius: 9px;
  max-height: 90vw;
  padding: 28px;
  background-color: #fff;
  position: absolute !important;
  top: 50%;
  width: 25vw;
  transform: translateY(-50%);
}
.modal-close {
  cursor: pointer;
  font-size: 28px;
  color: #fff;
  font-weight: bold;
  position: absolute;
  top: -28px;
  right: -28px;
}
@media only screen and (max-width: 768px) {
  .modal-content {
    width: 80% !important;
  }
}
</style>
